<!-- Index-1 component -->
<script>
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import Navbar from "../Components/Navbar.svelte";
  import Services from "../Components/PracticeAreas.svelte";
  import About from "../Components/About.svelte";
  import HomeHighlights from "../Components/HomeHighlights.svelte";
  // import Testimonial from "../Components/Testimonial.svelte";
  import Contact from "../Components/Contact.svelte";  
  import Footer from "../Components/Footer.svelte";

  import englishData from "../Data/data_english";
  import frenchData from "../Data/data_french";
  import spanishData from "../Data/data_spanish";
  import arabicData from "../Data/data_arabic";
  import { t, locale, locales } from "../Services/i18n";  

</script>

<!-- STRAT NAVBAR -->
<Navbar />
<!-- END NAVBAR -->

<section
  class="section section-lg home-half common-section"
  id="home"
  style="background-image: url('images/maite_cutout.png'); background-repeat: no-repeat; background-size: 30%; background-position: top 100px right 20px;">
  <div class="bg-overlay" />
  <div class="display-table">
    <div class="home-cell-bottom">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-white text-center">
            <h3>
              <select class="language-selector" bind:value={$locale}>
                {#each locales as l}
                  <option value={l}>{l}</option>
                {/each}
              </select>          
            </h3>              
            <h1 class="home-title"><h1>{$t("home.title")}</h1>            
            <!-- <h4>{$t("home.subtitle")}</h4> -->
            <p class="pt-5 home-desc">
              {$t("home.subtitle")}
            </p>
            <HomeHighlights teamData={englishData.TEAM_DATA} />
          <div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
 
<!--END HOME-->
<!--END HOME-->

{#if $locale == "English"}
  <Services serviceData={englishData.SERVICE_DATA} />
  <About teamData={englishData.TEAM_DATA} />
{:else if $locale == "Spanish"}
  <Services serviceData={spanishData.SERVICE_DATA} />
  <About teamData={spanishData.TEAM_DATA} />
{:else if $locale == "French"}
  <Services serviceData={frenchData.SERVICE_DATA} />
  <About teamData={frenchData.TEAM_DATA} /> 
{:else if $locale == "Arabic"}
  <Services serviceData={arabicData.SERVICE_DATA} />
  <About teamData={arabicData.TEAM_DATA} />   
{/if}         

<Contact />
<Footer />
